import React, { useState } from "react";
import styles from "./styles.module.css";


function LoaderAdmin() {
 
  return (
    <div style={{justifyContent: 'center',display:'flex',flexDirection: 'column',alignContent: 'center',position:'absolute',top:'40%',left:"45%"}}>
    <div className={styles.loader}>
    </div>
    <br/>
      <strong style={{marginLeft:'2em'}}>Submitting....</strong>
      </div>
  );
}

export default LoaderAdmin;
